import { Orders } from "models/server/Enums";

export class SortingParams {

    constructor(
        public sortField: string = null,
        public sort: Orders = Orders.Ascending
    ) { }
}